import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of, filter, forkJoin } from 'rxjs';
import { combineLatestWith, map } from 'rxjs/operators';

import {
  LoginSessionFacadeService,
  UserSettingsService,
} from '@digital-platform/users/services';
import { WasteProfileCardsService } from '../waste-profiles-cards/waste-profile-cards.service';

@Injectable({
  providedIn: 'root',
})
export class WasteProfilesLoaderGuard implements CanActivate {
  canActivate(): Observable<boolean> {
    return of(true);
  }
}

// class-based route guards and CanActivate/CanActivateChild are being deprecated in Angular 16 in favor of functional route guards
export const statusCardsLoader = () =>
  inject(WasteProfileCardsService)
    .loadStatusCards()
    .pipe(map(() => true));

export const internalStatusCardsLoader = () => {
  //console.log('IN INTERNAL ROUTE GUARD');
  const settings$ = inject(UserSettingsService).settings$.pipe(
    filter((settings) => !!settings)
  );

  const accessList$ = inject(LoginSessionFacadeService).accessList$;
  const cardsService = inject(WasteProfileCardsService);
  //clear out stores
  cardsService.clearCards();

  return accessList$.pipe(
    combineLatestWith(settings$),
    map(([access, settings]) =>
      cardsService.loadInternalCustomerCards(access, settings)
    ),
    map(() => true)
  );
};

export const externalStatusCardsLoader = () => {
  //console.log('IN  EXTERNAL ROUTE GUARD');
  const settings$ = inject(UserSettingsService).settings$.pipe(
    filter((settings) => !!settings)
  );
  const accessList$ = inject(LoginSessionFacadeService).accessList$;
  const cardsService = inject(WasteProfileCardsService);
  //clear out stores
  cardsService.clearCards();

  return accessList$.pipe(
    combineLatestWith(settings$),
    map(([access, settings]) =>
      cardsService.loadExternalCustomerCards(access, settings)
    ),
    map(() => true)
  );
};
